export type OrgInviteRole = 'owner' | 'member';

export type OrgInviteNotificationMeta = {
  orgId: string;
  token: string;
  businessName: string | null;
  logoURL: string | null;
  inviteStatus: string | null;
  invitedRole: OrgInviteRole;
  primaryAccountHolderName: string | null;
};

export function normalizeOrgInviteRole(value: unknown): OrgInviteRole {
  return String(value ?? '').trim().toLowerCase() === 'owner' ? 'owner' : 'member';
}

export function formatOrgInviteRoleLabel(role: OrgInviteRole): string {
  return role === 'owner' ? 'Primary account holder' : 'Member';
}

export function formatOrgInviteRolePhrase(role: OrgInviteRole): string {
  return role === 'owner' ? 'the primary account holder' : 'a member';
}

export function getOrgInviteNotificationMeta(notification: {
  type?: string | null;
  orgId?: string | null;
  data?: Record<string, unknown> | null;
}): OrgInviteNotificationMeta | null {
  if (notification.type !== 'org_invite') return null;
  const data = (notification.data ?? {}) as Record<string, unknown>;
  const token =
    typeof data.inviteToken === 'string' && data.inviteToken.trim()
      ? data.inviteToken.trim()
      : null;
  const orgId =
    typeof data.orgId === 'string' && data.orgId.trim()
      ? data.orgId.trim()
      : typeof notification.orgId === 'string' && notification.orgId.trim()
        ? notification.orgId.trim()
        : null;

  if (!orgId || !token) return null;

  return {
    orgId,
    token,
    businessName:
      typeof data.businessName === 'string' && data.businessName.trim()
        ? data.businessName.trim()
        : null,
    logoURL:
      typeof data.logoURL === 'string' && data.logoURL.trim()
        ? data.logoURL.trim()
        : null,
    inviteStatus:
      typeof data.inviteStatus === 'string' && data.inviteStatus.trim()
        ? data.inviteStatus.trim()
        : null,
    invitedRole: normalizeOrgInviteRole(data.invitedRole),
    primaryAccountHolderName:
      typeof data.primaryAccountHolderName === 'string' && data.primaryAccountHolderName.trim()
        ? data.primaryAccountHolderName.trim()
        : null,
  };
}
